import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom';
import FlexibleBrkrgeCalcu from "./Flexible-brokerage-calculate.svg";
import LatestSecureTechnology from "./Latest-Secure-Technology.svg";
import RoundClockSupport from "./Round-clock-support.svg";
import "./algoTestWhyChoose.css";
function algoTestWhyChoose(props) {
  // console.log(props);
  return (
    <>
      <section className="algoTestWhyChoose_section">
        <Container>
          <div className="section-heading center">
            Why Choose <span>Moneysukh</span>
          </div>
          <Row>
            <Col md={4}>
              <div className="algoTestWhyChoose_group FlexibleBrkrgeCalcu_panel">
                <div className="algoTestWhyChoose_panel">
                  <div className="algoTestWhyChoose_imgpanel">
                    <span>
                    <img src={FlexibleBrkrgeCalcu} alt="Flexible Brokerage Calculate" />
                    </span>
                    </div>
                  <h2>Flexible brokerage plans for Traders</h2>
                  <p>Triple benefits - Get instant pledge benefits , trade at Rs 10 per order*, complete tool kit.</p>
                  <div className="btn"> <Link to={'/Pricing'}><span>Learn More</span><i className="fa fa-angle-right"></i></Link> </div>
                  </div>
              </div>
              </Col>
              <Col md={4}>
              <div className="algoTestWhyChoose_group LatestSecureTechnology_panel">
                <div className="algoTestWhyChoose_panel">
                  <div className="algoTestWhyChoose_imgpanel">
                    <span>
                    <img src={LatestSecureTechnology} alt="Latest and Secure Technology" />
                    </span>
                    </div>
                  <h2>Latest and secure Technology</h2>
                  <p>Cloud based & user-friendly platform with latest features to help your trading decisions.</p>
                  <div className="btn"> <Link to={'/AlgoTrading'}><span>Learn More</span><i className="fa fa-angle-right"></i></Link> </div>
                  </div>
              </div>
              </Col>
              <Col md={4}>
              <div className="algoTestWhyChoose_group RoundClockSupport_panel">
                <div className="algoTestWhyChoose_panel">
                  <div className="algoTestWhyChoose_imgpanel">
                    <span>
                    <img src={RoundClockSupport} alt="Round the clock support" />
                    </span>
                    </div>
                  <h2>Round the clock support</h2>
                  <p>Constant support and trade with the help of dedicated research.</p>
                  <div className="btn"> <a href='https://support.moneysukh.com/' target="_blank"><span>Learn More</span><i className="fa fa-angle-right"></i></a> </div>
                  </div>
              </div>
              </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default algoTestWhyChoose;
